import config from "config/config";

import DEPRECATING_AGENTINFOCARD from "./DEPRECATING_AGENTINFOCARD";
import { default as RELEASING_AGENTINFOCARD } from "./AgentInfoCard.jsx";

export default function AgentInfoCard({ policy, policyDetail }) {
  if (config.ENABLE_ALL_AGENTS_IN_POLICY_DETAILS_ON_AGENT_PORTAL === "true")
    return <RELEASING_AGENTINFOCARD policyDetail={policyDetail} />;

  return (
    <DEPRECATING_AGENTINFOCARD policy={policy} policyDetail={policyDetail} />
  );
}
